/**
 * デフォルト情報
 * 長いから隔離
 */
export const defaultData = [
  {
    title: 'Subject1Subject1',
    icon: 'rocket_launch',
    path: '/a',
    subtitle: [],
  },
  {
    title: 'Subject2',
    icon: 'diamond',
    path: '/Test',
    subtitle: [
      {
        title: 'Subtitle1',
        icon: 'public',
        path: '/Test1',
        subjectIndex: 1,
        infoNumber: 87,
      },
      {
        title: 'Subtitle2',
        icon: 'emoji_nature',
        path: '/Test2',
        subjectIndex: 1,
      },
      {
        title: 'Subtitle3',
        icon: 'sunny',
        path: '/Test3',
        subjectIndex: 1,
      },
    ],
  },
  {
    title: 'Subject3',
    icon: 'grade',
		image: 'https://firebasestorage.googleapis.com/v0/b/testafterfollowconcierge.appspot.com/o/pointItem%2F0dj4fSgjuHwKSLT9hgqy%2F1.jpg?alt=media&token=9d6ac2d8-878a-4133-9570-dbccdada91f9',
    path: '/Test3',
    subtitle: [],
  },
  {
    title: 'Subject4',
    icon: 'thumb_up',
    path: '/Test4',
    subtitle: [
      {
        title: 'Subtitle4',
        icon: 'handshake',
        path: '/Test41',
        subjectIndex: 3,
      },
      {
        title: 'Subtitle5',
        icon: 'eco',
        path: '/Test42',
        subjectIndex: 3,
      },
      {
        title: 'Subtitle6',
        icon: 'emoji_people',
        path: '/Test43',
        subjectIndex: 3,
      },
      {
        title: 'Subtitle7',
        icon: 'recycling',
        path: '/Test44',
        subjectIndex: 3,
      },
      {
        title: 'Subtitle8',
        icon: 'wc',
        path: '/Test45',
        subjectIndex: 3,
      },
      {
        title: '顧客情報',
        icon: 'emoji_people',
        path: '/customer/setting',
        subjectIndex: 3,
      },
      {
        title: '管理者情報',
        icon: 'recycling',
        path: '/admin/setting',
        subjectIndex: 3,
      },
      {
        title: 'Subtitle11',
        icon: 'wc',
        path: '/Test46',
        subjectIndex: 3,
      },
    ],
  },
]
